export default {
  SET_SELECTED_PAYMENT (state, value) {
    state.selectedPayment = value
  },
  SET_TRANSACTION_PRODUCT (state, val) {
    state.transactionProduct = val
  },
  SET_TRANSACTION_PAYMENT (state, val) {
    state.transactionPayment = val
  },
  SET_TYPE_TRANSACTION (state, val) {
    state.transactionTypes = val
  },
  SET_HISTORY_TRANSACTION (state, val) {
    state.transactionHistory = val
  }
}